import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Workspace: 'live' or 'demo' — persisted in localStorage
export const getWorkspace = () => localStorage.getItem('flipn_workspace') || 'live';
export const setWorkspace = (ws) => localStorage.setItem('flipn_workspace', ws);

// Session token — for header fallback (cookie is primary)
export const getSessionToken = () => localStorage.getItem('flipn_token');
export const setSessionToken = (t) => localStorage.setItem('flipn_token', t);
export const clearSessionToken = () => localStorage.removeItem('flipn_token');

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Session-scoped cache-buster. Any GET request gets a `_v=<timestamp>` query
// param so the browser can NEVER serve a stale response from cache. New value
// per page-load, so a hard refresh guarantees fresh data.
const CACHE_BUSTER = String(Date.now());

api.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  cfg.headers['X-Workspace'] = getWorkspace();
  const t = getSessionToken();
  if (t) cfg.headers['Authorization'] = `Bearer ${t}`;
  // Force fresh responses — belt & braces alongside server-side Cache-Control
  cfg.headers['Cache-Control'] = 'no-cache';
  cfg.headers['Pragma'] = 'no-cache';
  if ((cfg.method || 'get').toLowerCase() === 'get') {
    cfg.params = { ...(cfg.params || {}), _v: CACHE_BUSTER };
  }
  return cfg;
});

export const AED = (n) => {
  if (n == null) return '—';
  // Idempotent: if input already looks like "AED …" or "aed …", strip that prefix first
  if (typeof n === 'string') {
    const cleaned = n.replace(/^\s*aed\s*/i, '').replace(/,/g, '').trim();
    n = parseFloat(cleaned);
  }
  if (isNaN(n)) return '—';
  return `AED ${Number(n).toLocaleString('en-AE', { maximumFractionDigits: 0 })}`;
};

export const AED_short = (n) => {
  if (n == null) return '—';
  // Idempotent: strip pre-existing "AED " prefix so we never render "AED AED 1.13M"
  if (typeof n === 'string') {
    const cleaned = n.replace(/^\s*aed\s*/i, '').replace(/,/g, '').trim();
    n = parseFloat(cleaned);
  }
  if (isNaN(n)) return '—';
  const num = Number(n);
  if (Math.abs(num) >= 1e6) return `AED ${(num / 1e6).toFixed(2)}M`;
  if (Math.abs(num) >= 1e3) return `AED ${(num / 1e3).toFixed(0)}K`;
  return `AED ${num.toFixed(0)}`;
};

export const fileUrl = (fileId) => {
  const t = getSessionToken();
  return `${API_BASE}/files/${fileId}${t ? `?auth=${t}` : ''}`;
};
